import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';

export function getNFTToken(
  client: PublicClient,
  { poolAddress }: { poolAddress: Address },
): Promise<Address> {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  return poolContract.read.ownershipNFT();
}
